export const SIDEBAR_SERVICE_OVERVIEW             = "service_overview";
export const SIDEBAR_PARTS_CHECKER                = "parts_checker";
// export const SIDEBAR_PARTS_IDENTIFIER             = "parts_identifier";
export const SIDEBAR_PARTS_IDENTIFIER             = "parts_identifier";
export const SIDEBAR_VEHICLE_LINKER               = "vehicle_linker";
export const SIDEBAR_PARTS_FINDER                 = 'parts_finder';
export const SIDEBAR_PART_LINKER_1                = 'parts_linker_1';

export const SIDEBAR_SETTINGS                     = "settings";
export const SIDEBAR_NOTIFICATIONS                = "notifications";
export const OE_PAPER_READOUT                     = "oe_paper_readout"

export const SERVICE_OVERVIEW_PATH                = "service-overview";
export const PARTS_CHECKER_PATH                   = "parts-checker";
export const GP_PARTS_CHECKER_PATH_IT             = "ca45593cbbdf";
// export const GP_PARTS_CHECKER_PATH_DE             = "bln5593ambge";
// export const PARTS_IDENTIFIER_PATH                = "parts-identifier";
export const PARTS_IDENTIFIER_PATH                = "parts-identifier";
export const VEHICLE_LINKER_PATH                  = 'vehicle-linker';
export const PARTS_FINDER_PATH                    = 'parts-finder';
export const PART_LINKER_1_PATH                   = 'parts-linker';
export const OE_PAPER_READOUT_PATH                = 'oe-readout'
export const SETTINGS_PATH                        = "settings";
export const NOTIFICATIONS_PATH                   = "notifications";

export const LOGIN_SUB_VIEW                       = "login";
export const RESET_PASSWORD_SUB_VIEW              = "reset_password";
export const REGISTER_SUB_VIEW                    = "register";

export const DEFAULT_LOCALE          						= "en-NZ";

export const PART_EQUIPMENT_LIST_STREAM         = "parts_list_stream";
export const PART_EQUIPMENT_LIST_CHANNEL        = "private-mechanic-parts-list-channel";
export const PART_OE_STREAM                     = "parts_oe_stream";
export const PART_OE_CHANNEL                    = "private-mechanic-parts-OE-channel";
export const PART_LIST_FROM_OE_STREAM           = "parts_list_from_oe_stream";
export const PART_LIST_FROM_OE_CHANNEL          = "private-mechanic-parts-list-from-OE-channel";
export const PART_STREAM_STATUS_FETCHING        = "fetching";
export const PART_STREAM_STATUS_COMPLETED       = "completed";
export const PART_STREAM_LIST_UMC               = "PEDNING";
export const PART_STREAM_LIST_PART              = "COMPLETED";
export const PART_STATUS_NOT_FOUND              = "PARTNOTFOUND";

// watcher constants
export const quickTimeout = 5000;
export const mediumTimeout = 15000;
export const longTimeout = 25000;

export const PARTS_DATA_RESULT_EVENT           = "PARTS_DATA_RESULT"
export const IFRAME_LOADING_EVENT              = "IFRAME_SETUP_STARTED"

// Country codes
export const ITALY_COUNTRY_CODE                = "IT";   